import { render, staticRenderFns } from "./global-functional.vue?vue&type=template&id=456a6c5d&scoped=true"
import script from "./global-functional.vue?vue&type=script&lang=ts"
export * from "./global-functional.vue?vue&type=script&lang=ts"
import style0 from "./global-functional.vue?vue&type=style&index=0&id=456a6c5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a6c5d",
  null
  
)

export default component.exports